import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
    <p><strong>Description</strong></p>
    <p>
        <span style="font-size: 14px; font-family: Arial, Helvetica, sans-serif;">
            Flow Balance is the ability to control the input rate and balance the output capability between both Induct and Stow processes. This is achieved by identifying the maximum stow capability for the shift and then working upstream to
            complete staffing for both Pick to Buffer and Inbound Dock roles (Induct, Line Loader, W/S etc). Achieving a balanced staffing model guarantees that the “at station” buffer never exceeds to standard of 15 minutes of work and the
            production system is working on single piece flow by not exceeding buffer limits or stow capabilities downstream. Success for flow balance is determined by the sites ability to maintain balance between induct flow per hour and stow
            flow per hour. The target range is established by matching induct FPH within +/- 5% of the stow FPH. As the stow process is the downstream customer of the sort operations, sort capability determines the process needs upstream roles
          &amp; staffing.
        </span>
    </p>
    <p><strong>Impact</strong></p>
    <p>
        <span style="font-size: 14px; font-family: Arial, Helvetica, sans-serif;">
            To improve flow of shift operations and drive consistency by measuring the balance of flow between upstream &amp; downstream processes. By managing the buffer &amp; at station limits between 15 to 30 minutes, this ensures that the
            down stream process paths (Stow &amp; P2B) consistently have work through the entire shift while minimizing any actions that degrade productivity.&nbsp;
        </span>
    </p>
    <p><strong>Resolution Steps</strong></p>
    <p>
      1) Verify inbound and stow headcount vs planned. If headcount is not at planned headcount, please staff
      accordingly.<br/>
      2) If headcounts are at planned, please open another induct table if applicable.<br/>
      3) If another induct table is not available, please remove stowers and add in the form of pushers in order to
      temporarily increase induct FPH.<br/>
      4) &nbsp;Once at-station is at 15 minutes of work, please staff to the planned headcounts provided by the SPT
      plan. <br/>
      &nbsp;&nbsp;
    </p>
    <p><strong>Supplemental Links</strong></p>
    <p>
      1) <span className="wikiinternallink"><a href="https://tiny.amazon.com/8fmuh1et/amazawsaworkindehtmlfold0e75">Flow Training PowerPoint</a></span><br/>
      2) <span className="wikiinternallink"><a
      href="https://broadcast.amazon.com/videos/361799">Training Broadcast</a></span><br/>
      3)
      <span className="wikiinternallink">
            <a
              href="https://us-east-1.quicksight.aws.amazon.com/sn/dashboards/816d5615-eb02-4834-82e5-524ed591a6b6/sheets/816d5615-eb02-4834-82e5-524ed591a6b6_1ab5f403-5d93-4a27-b843-74a901827b13">NA/EU Station Induct-Stow Flow Dashboard</a>
        </span>
      <br/>
      4) <span className="wikiexternallink"><a
      href="https://amazon.awsapps.com/workdocs/index.html#/folder/210748d2b7549d156317485a17f276161ba8b1c5b27408b83263820e9e026950">Central Flow Tools</a></span><br/>
      5) <span className="wikiexternallink"><a
      href="https://amazon.awsapps.com/workdocs/index.html#/folder/68b49c3893ba908cea63a221d51df86fc64515ba14a102ed5d514190d0414b62">Central Flow Standard Work</a></span><br/>
      6) <span className="wikiinternallink"><a href="https://broadcast.amazon.com/channels/33744">Central Flow Broadcast</a></span>
    </p>
  </div>`
);


// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Stow_WIP_too_low.jsx